import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./formTitle.css";
import "./themeCheckbox.css";
import "./themePlaceholder.css";
import FormHeader from "../common/FormHeader";

function WorkAtHeight() {
  const sigCanvasRef = useRef(null);
  const [form, setForm] = useState({
    description: "",
    experienced: false,
    workArea: {
      stable: false,
      tripHazards: false,
      clearVisitors: false,
      isolated: false,
      clearFree: false,
      controlled: false,
      preventDrop: false
    },
    equipment: {
      scaffoldErected: false,
      scaffoldAccess: false,
      towerErected: false,
      towerContractor: false,
      towerClient: false,
      towerHired: false,
      kickboards: false,
      ladderAppropriate: false,
      stepLadder: false,
      ladderCertified: false,
      mechHired: false,
      mechClient: false,
      workersQualified: false,
      equipmentChecked: false
    },
    fallArrest: {
      linesCertified: false,
      harnessAppropriate: false,
      harnessTrained: false,
      harnessWorking: false,
      harnessCertified: false
    },
    weather: {
      suitable: false
    },
    signature: ""
  });

  const handleChange = (section, field) => {
    if (section === "description" || section === "experienced") {
      setForm({ ...form, [section]: field });
    } else {
      setForm({
        ...form,
        [section]: {
          ...form[section],
          [field]: !form[section][field]
        }
      });
    }
  };

  const handleInput = (e) => {
    setForm({ ...form, description: e.target.value });
  };


  const clearSignature = () => {
    sigCanvasRef.current.clear();
    setForm(prev => ({
      ...prev,
      signature: ""
    }));
  };

  const saveSignature = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        signature: sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Work at Height Permit submitted!");
  };

  return (
    <div style={{ height: '100vh', overflowY: 'auto', background: '#f5f7fa' }}>
      <FormHeader />
      <div className="container py-4 position-relative">
        <button
  onClick={() => window.history.back()}
  className="btn fw-semibold position-absolute"
  style={{
    left: "-63px",
    color: "#8b1634",
    padding: "8px 20px",
    whiteSpace: "nowrap",
    zIndex: 10,
  }}
>
  <i className="fa fa-arrow-left"></i> Back
</button>
        <div className="card shadow-sm rounded-4 p-4">
          <h2
            className="text-center text-white py-2 mb-4 rounded"
            style={{
              backgroundColor: "#8b1634",
              letterSpacing: "1px",
              fontSize: "1.7rem"
            }}
          >
            Work at Height Permit
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <label className="form-label fw-semibold" style={{ color: '#8b1634' }}>
                  Brief Description of WAH Tasks
                </label>
                <textarea
                  value={form.description}
                  onChange={handleInput}
                  placeholder="Brief Description of WAH Tasks"
                  className="form-control custom-input"
                  required
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    minHeight: "90px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                />
              </div>
              <div className="col-12 col-md-6">
                <div className="p-3 h-100 d-flex flex-column justify-content-center border border-2 rounded-4 bg-light-subtle">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>WORKERS</div>
                  <div className="d-flex align-items-center justify-content-between fw-medium">
                    <span style={{ color: '#222' }}>Experienced at Working at Height</span>
                    <input type="checkbox" checked={form.experienced} onChange={() => handleChange("experienced", !form.experienced)} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
            </div>

            {/* Work Area & Equipment */}
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>WORK AREA</div>
                  {[
                    {label:'Surface is stable',field:'stable'},
                    {label:'Area clear of trip hazards',field:'tripHazards'},
                    {label:'Area clear of employees / visitors',field:'clearVisitors'},
                    {label:'Work area isolated',field:'isolated'},
                    {label:'Access to work area is clear / free',field:'clearFree'},
                    {label:'Access to work area is controlled',field:'controlled'},
                    {label:'Measures in place to prevent tools / equipment being dropped',field:'preventDrop'}
                  ].map(item => (
                    <div key={item.field} className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                      <span style={{color:'#222'}}>{item.label}</span>
                      <input type="checkbox" checked={form.workArea[item.field]} onChange={()=>handleChange("workArea", item.field)} className="form-check-input theme-checkbox" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>EQUIPMENT</div>
                  {[
                    {label:'Scaffold is erected correctly',field:'scaffoldErected'},
                    {label:'Scaffold has controlled access',field:'scaffoldAccess'},
                    {label:'Tower Scaffold erected correctly',field:'towerErected'},
                    {label:'Tower Scaffold is owned by contractors',field:'towerContractor'},
                    {label:'Tower Scaffold is owned by clients',field:'towerClient'},
                    {label:'Tower Scaffold is hired',field:'towerHired'},
                    {label:'Kickboards are intact',field:'kickboards'},
                    {label:'Ladder is appropriate for the task',field:'ladderAppropriate'},
                    {label:'Step ladders are appropriate for the task',field:'stepLadder'},
                    {label:'Ladders are certified for use (Scaff tag)',field:'ladderCertified'},
                    {label:'Mechanical / powered system hired',field:'mechHired'},
                    {label:'Mechanical powered system owned by client',field:'mechClient'},
                    {label:'Workers qualified / trained in correct use of mechanical equipment – PASMA / Ladder trained / IPAF',field:'workersQualified'},
                    {label:'Equipment used has been safety checked in the past six months',field:'equipmentChecked'}
                  ].map(item => (
                    <div key={item.field} className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                      <span style={{color:'#222'}}>{item.label}</span>
                      <input type="checkbox" checked={form.equipment[item.field]} onChange={()=>handleChange("equipment", item.field)} className="form-check-input theme-checkbox" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Fall Arrest & Weather */}
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>FALL ARREST</div>
                  {[
                    {label:'Safety lines certified and checked',field:'linesCertified'},
                    {label:'Workers have appropriate harness',field:'harnessAppropriate'},
                    {label:'Workers are trained in use of harness',field:'harnessTrained'},
                    {label:'Harness is in good working order',field:'harnessWorking'},
                    {label:'Harness has been certified for use',field:'harnessCertified'}
                  ].map(item => (
                    <div key={item.field} className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                      <span style={{color:'#222'}}>{item.label}</span>
                      <input type="checkbox" checked={form.fallArrest[item.field]} onChange={()=>handleChange("fallArrest", item.field)} className="form-check-input theme-checkbox" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>WEATHER</div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>Weather conditions are suitable / clear</span>
                    <input type="checkbox" checked={form.weather.suitable} onChange={()=>handleChange("weather", "suitable")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 fw-medium">
                    <span style={{color:'#222'}}>Weather conditions are monitored</span>
                    <input type="checkbox" checked={form.weather.monitored || false} onChange={()=>handleChange("weather", "monitored")} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
            </div>

            {/* OPERATIVES & RAIL */}
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>OPERATIVES</div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>Operatives are trained to use WAH equipment – ladders, towers, MEWPS</span>
                    <input type="checkbox" checked={form.operatives?.trained || false} onChange={()=>handleChange("operatives", "trained")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>Operatives reminded not to over reach</span>
                    <input type="checkbox" checked={form.operatives?.notOverreach || false} onChange={()=>handleChange("operatives", "notOverReach")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 fw-medium">
                    <span style={{color:'#222'}}>Operatives reminded to maintain clear work area to prevent objects falling</span>
                    <input type="checkbox" checked={form.operatives?.clearArea || false} onChange={()=>handleChange("operatives", "clearArea")} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>RAIL (IF APPLICABLE)</div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>Platform</span>
                    <input type="checkbox" checked={form.rail?.platform || false} onChange={()=>handleChange("rail", "platform")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 fw-medium">
                    <span style={{color:'#222'}}>Columns Inspected</span>
                    <input type="checkbox" checked={form.rail?.columnsInspected || false} onChange={()=>handleChange("rail", "columnsInspected")} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
            </div>

            {/* Condition of column hinges & OHL Line Inspections */}
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>Condition of column hinges</div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>No sign of rust all suitable for using counterbalance equipment</span>
                    <input type="checkbox" checked={form.columnHinges?.noRust || false} onChange={()=>handleChange("columnHinges", "noRust")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>Signs of wear and tear but safe to lower using counterbalance</span>
                    <input type="checkbox" checked={form.columnHinges?.wearSafe || false} onChange={()=>handleChange("columnHinges", "wearSafe")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 fw-medium">
                    <span style={{color:'#222'}}>Significant signs of rust – Column unsafe to lower</span>
                    <input type="checkbox" checked={form.columnHinges?.rustUnsafe || false} onChange={()=>handleChange("columnHinges", "rustUnsafe")} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="p-3 border border-2 rounded-4 bg-light-subtle h-100">
                  <div className="fw-bold mb-3" style={{ color: '#8b1634', fontSize: '1.1rem' }}>OHL Line Inspections</div>
                  <div className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>OHL lines appear to have intact protective rubber exterior coating</span>
                    <input type="checkbox" checked={form.ohlLines?.intact || false} onChange={()=>handleChange("ohlLines", "intact")} className="form-check-input theme-checkbox" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 fw-medium">
                    <span style={{color:'#222'}}>OHL Lines do not appear to have undamaged protective rubber exterior coating</span>
                    <input type="checkbox" checked={form.ohlLines?.notUndamaged || false} onChange={()=>handleChange("ohlLines", "notUndamaged")} className="form-check-input theme-checkbox" />
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom fields: PICOS Name, Date Issued, Start/Finish Time, Signature & Submit */}
            <div className="row mb-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <input type="text" placeholder="PICOS Name" className="form-control mb-3 custom-input"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                />
                <input type="text" placeholder="Date Issued" className="form-control mb-3 custom-input"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                />
                <input type="text" placeholder="Start Time" className="form-control mb-3 custom-input"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                />
                <input type="text" placeholder="Finish Time" className="form-control mb-3 custom-input"
                  style={{
                    background: "#f7fafd",
                    borderRadius: "10px",
                    border: "1.5px solid #eaf0fe",
                    fontSize: "1.08rem",
                    paddingLeft: "10px"
                  }}
                  onFocus={e => (e.target.style.borderColor = "#8b1634")}
                  onBlur={e => (e.target.style.borderColor = "#eaf0fe")}
                />
              </div>
              <div className="col-12 col-md-4">
                <div className="w-100">
                  <div className="fw-semibold mb-2" style={{ color: '#8b1634' }}>Signature</div>
                  <div style={{
                    width: '100%',
                    border: '2px solid #8b1634',
                    borderRadius: '18px',
                    background: '#e9cfd6',
                    padding: '0.5rem',
                    textAlign: 'left',
                    position: 'relative',
                    minHeight: '120px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}>
                    <SignatureCanvas
                      ref={sigCanvasRef}
                      penColor="#8b1634"
                      backgroundColor="#e9cfd6"
                      clearOnResize={false}
                      velocityFilterWeight={0.7}
                      minWidth={1}
                      maxWidth={2.5}
                      dotSize={1.5}
                      throttle={16}
                      canvasProps={{
                        width: window.innerWidth > 600 ? 350 : 300,
                        height: 100,
                        style: {
                          width: '100%',
                          height: '100px',
                          border: 'none',
                          borderRadius: '18px',
                          background: '#e9cfd6',
                          display: 'block',
                          touchAction: 'none'
                        }
                      }}
                      onEnd={saveSignature}
                    />
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: '4px'
                    }}>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm rounded-pill px-3"
                        style={{
                          background: 'transparent',
                          color: '#8b1634',
                          borderColor: '#8b1634'
                        }}
                        onClick={clearSignature}>
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
  <div className="col-12 d-flex justify-content-center">
    <button
      type="submit"
      className="btn btn-lg text-white fw-bold px-5 py-2 mt-4"
      style={{
        backgroundColor: "#8b1634",
        borderRadius: "30px",
        boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
      }}
    >
      Submit
    </button>
  </div>
</div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default WorkAtHeight;
